var map = {
	"./GreyhoundRaces_dark_bg.jpg": "./src/assets/GreyhoundRaces_dark_bg.jpg",
	"./VirtualGreyhoundRaces_dark_bg.jpg": "./src/assets/VirtualGreyhoundRaces_dark_bg.jpg",
	"./VirtualHorseRaces_dark_bg.jpg": "./src/assets/VirtualHorseRaces_dark_bg.jpg",
	"./VirtualMotorcycleSpeedway_dark_bg.jpg": "./src/assets/VirtualMotorcycleSpeedway_dark_bg.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*_dark_bg\\.jpg$";